import { registerComponent } from '../../utils/vueUtils';

import DafaultHeader from './DafaultHeader.vue';
registerComponent(DafaultHeader);
import DefaultFooter from './DefaultFooter.vue';
registerComponent(DefaultFooter);
import PdfAdditionalData from './PdfAdditionalData.vue';
registerComponent(PdfAdditionalData);
import Icon from './Icon.vue';
registerComponent(Icon);
